import { FC, MutableRefObject, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { useTenantInfo } from '@/common/hook/useTenantInfo';
import { globalFranchiseeAlias } from '@/common/utils/ways';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Index from './index';

/**
 * 拓店任务-新增/编辑-抽屉
 * @description 拓店任务：加盟+直营A（基诺浦）、加盟+直营B（一鸣）
 */
const ExpansionFranchiseeCircleTaskEditDrawer:FC<{
  reload,
  onClose?,
  businessInfo?,
  isBusiness?,
  /** isFromFranchisee时用 */
  franchiseeId?,
  /** 从加盟商列表过来 */
  isFromFranchisee?: boolean,
  ref?: any,
}> = forwardRef(({
  reload,
  onClose,
  businessInfo,
  isBusiness,
  franchiseeId, // isFromFranchisee时用
  isFromFranchisee = false, // 从加盟商列表过来
}, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  const { tenantInfo } = useTenantInfo();

  const [open, setOpen] = useState(false); // 弹出框是否打开
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();
  const franchiseeAlias = globalFranchiseeAlias(tenantInfo.globalAliasItemVOs);

  // const [container, setContainer] = useState<HTMLElement | null>(null);
  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       const target = drawerWrapper.current?.getBodyElement();
  //       target && setContainer(target);
  //     }, 0);
  //   }
  // }, [open]);

  const methods = useMethods({

    init: () => {
      setOpen(true);

      setTimeout(() => {
        drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
        detail.current.init instanceof Function && detail.current.init();
      }, 0);
    },

    handleClose: () => {
      setOpen(false);
      onClose?.();
    },

  });

  return (
    <V2Drawer
      onRef={drawerWrapper}
      open={open}
      bodyStyle={{ padding: 0, }}
      onClose={methods.handleClose}
      maskClosable={false}
      push={false}
    >
      {open && <Index
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        franchiseeId={franchiseeId}
        isFromFranchisee={isFromFranchisee}
        reload={reload}
        ref={detail}
        // container={container}
        onClose={methods.handleClose}
        franchiseeAlias={franchiseeAlias}
        style={{ height: '100%' }}
      />}
    </V2Drawer>
  );
});

export default ExpansionFranchiseeCircleTaskEditDrawer;
